module.exports = __webpack_public_path__ + "img/ResearchHUB Guiding Principles 11 06 2024-5.5f58e76e.png";